import { scrollToTop } from '@helpers/utils'
import { Button, SubmitButton } from '@components/ui/Button'
import PriceComparison from '@components/ui/PriceComparison'
import { AddToCartButtonProps } from '@components/product/AddToCartButton'
import { EmptyObject } from 'types/helpers'
import { ProductOption, ProductWithVariants } from 'types/product'
import styles from './styles.module.scss'
import { SubmitButtonHandlers } from '@components/ui/Button/SubmitButton'

export const FILTER_SCROLL_THRESHOLD = 70 // Accounts for floating main nav

export type StickyAddToCart = AddToCartButtonProps & {
  productColor: string
  isSelectedProductOutOfStock: boolean
  hasAllVariantOptionsSelected: boolean
  emptyOptions: ProductOption[]
  selectedProduct?: ProductWithVariants | EmptyObject
  isBundle?: boolean
}
export default function StickyAddToCart({
  label,
  active,
  onAddToCart,
  onOutOfStock,
  handle,
  productColor,
  hasAllVariantOptionsSelected,
  selectedProduct = {},
  emptyOptions,
  isSelectedProductOutOfStock,
  isBundle
}: StickyAddToCart) {
  const handleSelectEmptyOption = (type: string) => {
    const elementToScroll = document.getElementById(`filter-fit-option-${type}`)
    if (elementToScroll) {
      scrollToTop(elementToScroll?.offsetTop - FILTER_SCROLL_THRESHOLD)
    }
  }

  const handleAddToCart = (args: SubmitButtonHandlers) => {
    if (isBundle && label?.toLowerCase() !== 'add suit to basket') {
      const elementToScroll = document.getElementById(`product-tabs`)

      if (elementToScroll) {
        scrollToTop(elementToScroll?.offsetTop - 70)
      }
    }

    onAddToCart?.(args)
  }

  return (
    <div className={styles.stickyContainer}>
      <div className={styles.productInfo}>
        <h4>{selectedProduct.display_name}</h4>
        <p>{productColor}</p>
      </div>
      <PriceComparison
        classes={styles.productPrice}
        price={selectedProduct.price}
        fullPrice={selectedProduct.compare_at_price}
        size="medium-bold"
      />
      <div className={styles.buttonContainer}>
        {isSelectedProductOutOfStock && (
          <Button
            size={'large'}
            variant="secondary"
            fullWidth="always"
            onClick={onOutOfStock}
          >
            Notify me when back in stock
          </Button>
        )}
        {!isSelectedProductOutOfStock &&
          (hasAllVariantOptionsSelected ? (
            <SubmitButton
              size={'large'}
              classes={`add-to-cart add-to-cart-${handle}`}
              onClick={handleAddToCart}
              disabled={!active}
              fullWidth="always"
            >
              {label}
            </SubmitButton>
          ) : (
            <Button
              size={'large'}
              variant="secondary"
              fullWidth="always"
              onClick={() => handleSelectEmptyOption(emptyOptions[0]?.type)}
            >
              Select {emptyOptions[0]?.name}
            </Button>
          ))}
      </div>
    </div>
  )
}
